export default "__VITE_ASSET__DBO$ryOj__"